<template>
  <article class="page-container bg-white with-image" v-if="page">
    <header class="page-header">
      <div class="page-thumbnail" v-if="page.image_url">
        <img
          :src="$options.filters.imageproxy(page.image_url, 1160)"
          alt="Page Thumbnail"
        />
      </div>
      <h1 class="page-title" v-if="page.title">{{ page.title }}</h1>
    </header>

    <a class="button btn-with-icon btn-arrow button-get-the-card" :href="`https://www.kaerntencard.at/${this.$store.state.season}/jetzt-kaernten-card-sichern`" target="_blank">{{
      $t("getTheKaerntenCard")
    }}</a>

    <section class="page-content" v-html="page.content" />

    <section class="page-additional-content" v-html="page.additional_content" />

    <section class="page-infos">
      <h2>FAQ</h2>
      <accordion :items="page.infos" />
    </section>
  </article>
</template>

<script>
import checkforupdates from "@/mixins/checkforupdates.js";
import Accordion from "@/components/foundation/Accordion.vue";

export default {
  name: "SingleCardInfoPage",
  mixins: [checkforupdates],
  components: {
    Accordion,
  },
  metaInfo() {
    return {
      title: "Kärnten Card App",
      meta: [
        {
          property: "og:title",
          content: "Kärnten Card App",
        },
        {
          property: "og:site_name",
          content: "Kärnten Card App",
        },
        {
          property: "og:url",
          content: window.location.href,
        },
        {
          property: "og:image",
          content:
            this.page === null
              ? ""
              : this.$options.filters.imageproxy(this.page.image_url, 600) ||
                "",
        },
        {
          property: "og:description",
          content: this.page === null ? "" : this.page.content || "",
        },
      ],
    };
  },

  computed: {
    requestedPageName() {
      return this.$route.name;
    },
    page() {
      if (this.requestedPageName === "home") {
        return this.$store.getters.getCardInfoPageByName(
          this.requestedPageName
        );
      }
      if (
        this.requestedPageName === "single-card-info" &&
        this.$route.params.uuid
      ) {
        return this.$store.getters.getCardInfoByID(this.$route.params.uuid);
      }

      return null;
    },
  },
  watch: {
    "$store.state.language": function(newLang) {
      this.$store
        .dispatch("fetchCardInfos", {
          lang: newLang,
          season: this.$store.state.season,
        })
        .then(() => {
          this.$store.dispatch("fetchNews", {
            lang: newLang,
            season: this.$store.state.season,
          });
        });
    },
    "$store.state.season": function(newSeason) {
      this.$store
        .dispatch("fetchCardInfos", {
          lang: this.$store.state.language,
          season: newSeason,
        })
        .then(() => {
          this.$store.dispatch("fetchNews", {
            lang: this.$store.state.language,
            season: newSeason,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  text-align: center;
  color: get-color(primary);
  font-weight: bold;
}
</style>

<style lang="scss">
.page-container {
  margin-top: 0rem !important;
  padding-top: 0 !important;
}

.page-content h2,
.page-infos h2 {
  display: inline-block;
  margin-top: 2rem;
  font-size: 1.9rem;
  font-weight: bold;
}

.button.button-get-the-card {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.page-thumbnail {
  margin-bottom: 30vw !important;
  margin-left: -1.25rem !important;
  margin-right: -1.25rem !important;
  position: relative;

  &:after {
    content: "";
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
    height: 28.5vw;
    background: url("/img/3d-ktn-card.svg") no-repeat;
    background-size: contain;
    position: absolute;
    left: 30%;
    bottom: -20vw;
  }

  @media (min-width: 800px) {
    margin-bottom: 200px !important;
    &:after {
      width: 320px;
      height: 228px;
      bottom: -150px;
      left: calc(50% - 160px);
    }
  }
}
.notification-shell {
  text-align: center;
  color: $white;

  .notification-content {
    line-height: 1.2;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  .btn-update {
    @include button(
      false,
      get-color(secondary),
      scale-color(get-color(secondary), $lightness: 20%),
      $dark-gray,
      "solid"
    );
    margin-bottom: 0.5rem;
  }
}
</style>
